import { inject, Injectable, signal } from '@angular/core';
import { FAQ_CATEGORY_MODEL, FAQ_MODEL } from '@banyan/commons/consts/builder-io-model.const';
import { FAQ, FAQCategory } from '@banyan/commons/models/faq.model';
import { BuilderService } from '@banyan/modules/builder-io/services/builder.service';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, from, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FAQService {
  translateService = inject(TranslateService);
  builderService = inject(BuilderService);
  getFAQsOptions: any = {
    fields: 'id,name,data.question,data.answer,data.category',
    limit: 100,
    locale: this.translateService.currentLang || 'en',
    noTargeting: true,
  };
  getFAQCategoriesOptions: any = {
    fields: 'id,name,data.label',
    limit: 50,
    locale: this.translateService.currentLang || 'en',
    noTargeting: true,
  };
  faqs = signal<FAQ[]>([]);
  faqCategories = signal<FAQCategory[]>([]);
  activeCategory = signal<string>('');

  constructor() {
  }

  getFAQs() {
    this.getFAQsOptions.locale = this.translateService.currentLang;
    this.getFAQCategoriesOptions.locale = this.translateService.currentLang;
    forkJoin([
      from(this.builderService.fetchData(FAQ_MODEL, this.getFAQsOptions)).pipe(map(result => {
        return result.map((r: any) => {
          return {
            id: r.id,
            category: r.data.category.id,
            question: r.data.question,
            answer: r.data.answer,
          };
        });
      })),
      from(this.builderService.fetchData(FAQ_CATEGORY_MODEL, this.getFAQCategoriesOptions)).pipe(map(result => {
        const categories = result.map(r => {
          const name = r.data ? r.data['label'] : r.name;
          return {
            id: `${r.id}`,
            name,
          };
        });
        this.activeCategory.set(categories[0].id);
        return categories;
      })),
    ]).subscribe((result) => {
      this.faqs.set(result[0]);
      this.faqCategories.set(result[1]);
    });
  }
}
